<div class="container ">

  <app-shared-action-bar [saveReady]="checkForChange()" [undoReady]="checkForChange()" [displayActionSectionBar]="showActionSectionBar"
  (saveRequest)="validateSave()" (undoRequest)="resetLocations()"></app-shared-action-bar>




  <div class="px-4 md:px-8 mt-20">
    <div>
      @if (!isGroup) {
        <div class="my-4">
          <h2 class="settings-header">User Locations</h2>
        </div>
      }
      @if (isGroup) {
        <div class="my-4">
          <h2 class="settings-header">Group Locations</h2>
        </div>
      }

    </div>
    <div class="">
      @if (showUsersDDL) {
        <div class="mt-4 ">

          <div class="flex flex-col-reverse md:flex-row  mt-2">
            <select class=" text-box md:w-2/5 md:mr-2" [(ngModel)]="selectedUser"
              (ngModelChange)="clearLocationList()">
              @for (u of userListView; track u) {
                <option [disabled]="u.UserID == -1" [ngValue]="u">
                  {{u.DisplayName}}
                </option>
              }
            </select>
            <input type="text" class="text-box w-full  md:w-2/5" [(ngModel)]="userFilterString"
              placeholder="User Search" (keyup)="buildUserView()" />
            </div>
            <button (click)="loadUser()" class="btn-primary mt-4" [disabled]="isLoadingLocations">@if (!isLoadingLocations) {
              <span
              >Load</span>
              }@if (isLoadingLocations) {
              <span
              >Loading...</span>
            }</button>
          </div>
        }
        @if (!showUsersDDL && selectedUser.UserID!=-1) {
          <div class="mt-4 flex items-center">
            <p class="settings-selected-item mr-2">{{selectedUser.DisplayName}} </p><span (click)="showDDL()"
            class="hover:cursor-pointer text-xl material-symbols-outlined">
            edit
          </span>
        </div>
      }

      <div class="border-solid border-[1px] border-grey-500 mb-1 mt-3 "></div>

      @if (locationListView.length>0) {
        <div class="my-3 px-2 md:px-6">
          <!--<div class="mb-4">
          <button class="btn-primary w-full md:w-2/5" (click)="validateSave()">Save</button>
        </div>-->
        <table class="w-full md:w-2/5">
          <tbody>
            <tr class="border-b-offblack border-b-2 mb-2 py-1">
              <td class="font-bold">All</td>
              <td class="flex justify-center py-2 pl-3">
                <app-toggle-switch [(checked)]="allPermissions"
                (checkedChange)="updateAllPermissions()"></app-toggle-switch>
              </td>
            </tr>
            @for (l of locationListView; track l) {
              <tr>
                <td
                  [ngClass]="{'pl-1':l.LocationLevelSeq==minLocationLevel+1,'pl-3':l.LocationLevelSeq==minLocationLevel+2,'pl-6':l.LocationLevelSeq==minLocationLevel+3,'pl-8':l.LocationLevelSeq==minLocationLevel+4}">
                  {{l.LocationName}}
                </td>
                <td class="flex justify-center py-2 pl-3">
                  <app-toggle-switch [(checked)]="l.HasPermission"
                  (checkedChange)="validateAllPermissions()"></app-toggle-switch>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }

  </div>
</div>


</div>
